



















import Vue from 'vue'
import Header from './components/Header.vue'
import NetworkErrorDialog from './components/dialogs/NetworkError.vue'

import { language_t } from '@/store/modules/pref'
import { ppp, generateFakeDevs } from '@/utils'
import { setLang } from '@/i18n'
import easyapi from '@/easyapi'

// let FETCH_INTERVAL = -1
export default Vue.extend({
  components: {
    Header,
    NetworkErrorDialog
  },
  mounted () {
    setLang(this, this.$s.$state.pref.global.lang)
  },
  computed: {
    initializing (): boolean {
      if (this.$s.$state.auth.isLoggedIn) {
        return !this.$s.$state.device.firstTimeFetched
      }
      return false
    }
  },
  watch: {
    '$s.$state.pref.global.lang' (newVal: language_t) {
      setLang(this, newVal)
    },
    '$s.$state.auth.isLoggedIn' (newVal: boolean) {
      // window.clearInterval(FETCH_INTERVAL)
      // if (newVal) {
        // easyapi.fetchDeviceList().then((ok) => {
        //   FETCH_INTERVAL = window.setInterval(() => {
        //     // TODO: If network has error, pause the interval?
        //     // FIXME: Setup this interval in easyapi?
        //     easyapi.fetchDeviceList()
        //   }, 6000)
        // })
        // }
    }
  }
})
